<div mat-dialog-title class="dialog-title">
  <h1>
    <span>
      Toekomstige ritten van <b>{{ data.user.name }}</b> bekijken
    </span>
  </h1>
</div>

<div mat-dialog-content class="dialog-content">
  @if (loading()) {
    <div class="spinner-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    @if (usesAutomaticPlanning) {
      <mat-tab-group
        class="rides-tabs"
        [selectedIndex]="selectedTabIndex()"
        (selectedIndexChange)="onTabChange($event)"
        (animationDone)="onAnimationDone()"
      >
        <mat-tab label="Voorbereide ritten"></mat-tab>
        <mat-tab label="Geplande ritten"></mat-tab>
      </mat-tab-group>

      <div class="rides-tab-content-wrapper">
        <div
          [class.hidden]="selectedTabIndex() !== 0"
          class="rides-list-tab-container"
          [class.has-rides]="plannedRides().length > 0 || automaticRides().length > 0"
        >
          <ng-container
            *ngTemplateOutlet="
              ridesList;
              context: {
                rides: automaticRides(),
                emptyMsg: 'Er zijn geen voorbereide ritten voor deze passagier.',
                viewportId: 'automatic',
              }
            "
          ></ng-container>
        </div>

        <div
          [class.hidden]="selectedTabIndex() !== 1"
          class="rides-list-tab-container"
          [class.has-rides]="plannedRides().length > 0 || automaticRides().length > 0"
        >
          <ng-container
            *ngTemplateOutlet="
              ridesList;
              context: {
                rides: plannedRides(),
                emptyMsg: 'Er zijn geen geplande ritten voor deze passagier.',
                viewportId: 'planned',
              }
            "
          ></ng-container>
        </div>
      </div>
    } @else {
      <!-- Non-automatic planning view (just list) -->
      <div class="rides-list-tab-container" [class.has-rides]="plannedRides().length > 0">
        <ng-container
          *ngTemplateOutlet="
            ridesList;
            context: {
              rides: plannedRides(),
              emptyMsg: 'Er zijn geen geplande ritten voor deze passagier.',
              viewportId: 'planned',
            }
          "
        ></ng-container>
      </div>
    }
  }
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button mat-dialog-close>Sluiten</button>
</div>

<ng-template #ridesList let-rides="rides" let-emptyMsg="emptyMsg" let-viewportId="viewportId">
  @if (rides.length === 0) {
    <p class="empty-message">{{ emptyMsg }}</p>
  } @else {
    <cdk-virtual-scroll-viewport
      [id]="viewportId"
      [itemSize]="rideItemSize"
      [minBufferPx]="rideItemSize * 3"
      [maxBufferPx]="rideItemSize * 6"
      [style.--ride-item-size]="rideItemSize + 'px'"
      class="rides-viewport"
      role="list"
      aria-label="Toekomstige ritten"
    >
      <div *cdkVirtualFor="let ride of rides; trackBy: trackById" class="ride-card-wrapper" role="listitem">
        <div class="ride-card" [style.border-left-color]="ride.cardColor || '#5742e8'">
          <div class="ride-card-header">
            <h3 class="ride-date">{{ formatDate(ride.pickupTime) }}</h3>
          </div>
          <div class="ride-card-body">
            <div class="ride-info-row">
              <mat-icon>schedule</mat-icon>
              <span class="info-label">Tijd:</span>
              <span class="info-value">{{ formatTime(ride.pickupTime) }} - {{ formatTime(ride.dropoffTime) }}</span>
            </div>
            <div class="ride-info-row">
              <mat-icon class="location-icon">location_on</mat-icon>
              <span class="info-label">Van:</span>
              <span class="info-value" (mouseenter)="onMouseEnter($event, getAddressString(ride.from))">{{
                getAddressString(ride.from)
              }}</span>
            </div>
            <div class="ride-info-row">
              <mat-icon class="location-icon">location_on</mat-icon>
              <span class="info-label">Naar:</span>
              <span class="info-value" (mouseenter)="onMouseEnter($event, getAddressString(ride.to))">{{
                getAddressString(ride.to)
              }}</span>
            </div>
            @if (ride.vehicleName) {
              <div class="ride-info-row">
                <mat-icon>directions_car</mat-icon>
                <span class="info-label">Voertuig:</span>
                <span class="info-value" (mouseenter)="onMouseEnter($event, ride.vehicleName)">{{
                  ride.vehicleName
                }}</span>
              </div>
            }
            @if (ride.automaticallyPlanned === true) {
              <div class="ride-info-row original-time-row">
                <mat-icon>schedule</mat-icon>
                <span class="info-label">Oorspronkelijke tijd:</span>
                @if (ride.originalUserPickUpTime || ride.originalUserDropOffTime) {
                  <span class="info-value">
                    {{ formatTime(ride.originalUserPickUpTime) || 'niet van toepassing' }} -
                    {{ formatTime(ride.originalUserDropOffTime) || 'niet van toepassing' }}
                  </span>
                } @else {
                  <span class="info-value">niet van toepassing</span>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  }
</ng-template>
